import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {addDays} from '../Util/dateTime';
import $ from 'jquery'
require("../../Content/Less/rangeDatePickerStyles.css");
/* if you will adjust datepicker settings ->
	read the docs and eat your vegestables bro !
https://bootstrap-datepicker.readthedocs.org/en/latest/options.html*/
require('bootstrap-datepicker')
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.da.js')

class RangeDatePicker extends Component {
	componentDidMount() {
    const { defaultStartDate } = this.props;
		this.$rangePicker = $(ReactDOM.findDOMNode(this.refs.range));
    this.$rangePicker.datepicker({
      inputs: $('.range-start, .range-end'),
      format: 'DD d MM yyyy',
      autoclose: true,
      daysOfWeekDisabled: "0,2,3,4,5,6",
      language: 'da-DA',
      calendarWeeks: true,
      todayHighlight: false,
      weekStart: '1'
    }).on('changeDate', this.onDatepickerChange);

    if(defaultStartDate){
      this.onDatepickerChange({date: defaultStartDate})
    }

	}
	componentWillUnmount = () => {
		this.$rangePicker.datepicker('remove');
	};
	onDatepickerChange = (evt) => {

    evt.date.setHours(0,0,0,0)
    let newDate = addDays(evt.date, 13)
    $('.range-start').datepicker('update', evt.date);
    $('.range-end').datepicker('update', newDate);
    this.$rangePicker.datepicker('updateDates');
    this.props.onChange(evt.date, newDate);
	};
	render() {
		return (
      <div ref="range" className="range">
          <div className="range-start"></div>
          <div style={{display: 'none'}} className="range-end"></div>
      </div>
		);
	}
}
	RangeDatePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultStartDate: PropTypes.instanceOf(Date)
  };
export default RangeDatePicker


// WEBPACK FOOTER //
// ./src/App/Common/rangeDatePicker.jsx